export default __webpack_public_path__ + "static/media/tr.b8865d8f.png";